import React from 'react'
import { camelCase } from 'lodash'
import {
  IProps as ICardsWithIcon,
  CardsWithIcon,
} from 'marketing-site/src/library/components/CardsWithIcon'

import { ICardsWithIcon as IContentfulCardsWithIcon } from 'marketing-site/@types/generated/contentful'
import { transformCardWithIcon } from 'marketing-site/src/transformers/elements/ContentfulCardWithIcon'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { getTypedHeadingStyle } from 'marketing-site/src/library/utils'

export const ContentfulCardsWithIcon = (cards: IContentfulCardsWithIcon): React.ReactElement => (
  <EntryMarker entry={cards}>
    {() => <CardsWithIcon {...transformCardsWithIcon(cards)} />}
  </EntryMarker>
)

export function transformCardsWithIcon({ fields }: IContentfulCardsWithIcon): ICardsWithIcon {
  return {
    ...fields,
    header: fields.header,
    headerFontStyle: fields.headingStyle && getTypedHeadingStyle(fields.headingStyle),
    subheader: fields.subheader,
    cards: fields.cardsWithIcon.map((card) => transformCardWithIcon(card)),
    backgroundColor:
      fields.backgroundColor &&
      (camelCase(fields.backgroundColor) as ICardsWithIcon['backgroundColor']),
  }
}
